import { useAuthentication } from '@/hooks/useAuthentication';
import { useGetLiftOperatorQuery } from '@/api/v2/liftOperator';

/**
 * Whether the widget editor is offered to the lift operator of the current
 * session. Backed by the `widgetsEnabled` flag maintained in the backoffice
 * ("Widget-Editor aktivieren").
 *
 * Fails closed: without a resolvable lift operator the editor counts as
 * disabled. Only the navigation entry depends on it; the route itself stays
 * reachable.
 */
export const useWidgetEditorEnabled = (): {
    enabled: boolean;
    isLoading: boolean;
} => {
    const { liftOperatorData } = useAuthentication();
    const liftOperatorId = liftOperatorData?.liftOperatorId;
    const skip = !liftOperatorId;

    // currentData, not data: after a lift operator switch `data` still holds the
    // previous one, which would briefly show the entry for the wrong operator.
    const { currentData, isFetching } = useGetLiftOperatorQuery(
        { liftOperatorId },
        { skip }
    );

    return {
        enabled: currentData?.widgetsEnabled === true,
        isLoading: !skip && currentData === undefined && isFetching,
    };
};
